import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { trackCallClick } from "@/lib/googleAds";
import { Reveal } from "@/components/Reveal";

const Footer = () => (
  <footer className="border-t border-white/10 pt-24 pb-10 overflow-hidden" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6">
      <Reveal>
        <h2 className="font-oswald font-bold uppercase text-[14vw] md:text-[10vw] leading-[0.85] tracking-tighter text-stroke text-center select-none" data-testid="footer-verdict-type">
          Only Reviews
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="font-mono-p text-sm text-[#A1A1AA] text-center max-w-xl mx-auto mt-8 leading-relaxed">
          There is no universal winner — only the right machine for your workload.
          That's the verdict. Everything else is detail.
        </p>
        <a
          href="tel:+18884999335"
          onClick={trackCallClick("tel:+18884999335")}
          data-testid="footer-phone-link"
          className="flex items-center justify-center gap-3 mt-8 font-oswald text-lg tracking-[0.2em] text-[#F5F5F5] hover:text-[#0055FF] transition-colors duration-300"
        >
          <Phone className="w-4 h-4" /> +1 888-499-9335
        </a>
      </Reveal>

      <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-6">
        <span className="font-oswald text-sm tracking-[0.15em] lowercase">
          onlyreviews<span className="text-[#0055FF]">.</span><span className="text-[#FF3300]">blog</span>
        </span>
        <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
          <Link to="/antivirus" data-testid="footer-link-antivirus" className="font-mono-p text-xs tracking-[0.2em] uppercase text-[#A1A1AA] hover:text-[#F5F5F5] transition-colors duration-300">Antivirus</Link>
          <Link to="/about" data-testid="footer-link-about" className="font-mono-p text-xs tracking-[0.2em] uppercase text-[#A1A1AA] hover:text-[#F5F5F5] transition-colors duration-300">About</Link>
          <Link to="/privacy-policy" data-testid="footer-link-privacy" className="font-mono-p text-xs tracking-[0.2em] uppercase text-[#A1A1AA] hover:text-[#F5F5F5] transition-colors duration-300">Privacy Policy</Link>
          <Link to="/disclaimer" data-testid="footer-link-disclaimer" className="font-mono-p text-xs tracking-[0.2em] uppercase text-[#A1A1AA] hover:text-[#F5F5F5] transition-colors duration-300">Disclaimer</Link>
          <Link to="/contact" data-testid="footer-link-contact" className="font-mono-p text-xs tracking-[0.2em] uppercase text-[#A1A1AA] hover:text-[#F5F5F5] transition-colors duration-300">Contact</Link>
          <Link to="/brand" data-testid="footer-link-brand" className="font-mono-p text-xs tracking-[0.2em] uppercase text-[#A1A1AA] hover:text-[#F5F5F5] transition-colors duration-300">Logo</Link>
        </nav>
        <span className="font-mono-p text-[10px] tracking-[0.2em] uppercase text-[#A1A1AA]">
          © 2026 onlyreviews.blog — independent & unaffiliated.
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
